export type ToolbarItemProps = {
  id: string;
  mode: ToolbarItemMode;
  ariaLabel: string;
  label?: string;
  icon?: React.ReactNode;
  items?: DropdownItem[];
  selectedKey?: string;
  onSelect?: (key: string) => void;
  renderPanel?: (close: () => void) => React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  className?: string;
  panelClassName?: string;
};

export type DropdownItem = {
  key: string;
  label: string;
  icon?: React.ReactNode;
};

export enum ToolbarItemMode {
  DROPDOWN = 'dropdown',
  PANEL = 'panel',
}
